import React, {useEffect} from 'react'
import logo from 'public/img/brand/1.png'
import { Link } from "react-router-dom";
import {HeaderTools} from "./header-tools";
import './header.scss'
import { GET_CONFIG } from "app/queries/Config";
import { useQuery } from "@apollo/react-hooks";

export function Header() {
  const getConfig: any = useQuery(GET_CONFIG);
  const pricePerPerson = getConfig.data?.config.pricePerPerson;
  const pricePerMile = getConfig.data?.config.pricePerMile;

  return (
    <div className='row py-3 py-md-5 px-0 px-md-5 header'>
      <div className='col-12 col-md-3 text-center logo'>
        <a href='https://www.lakeozarkswatertaxi.com/'>
          <img src={logo} alt='logo' className='img-fluid' />
        </a>
      </div>
      <HeaderTools />
      <div className='col-12 text-center mt-2'>
        <h1 className='d-none d-md-block'><Link to='' className='text-brand'>Get A Quote!</Link></h1>
        <h2 className='d-block d-md-none'><Link to='' className='text-brand'>Get A Quote!</Link></h2>
        <span className='text-white'>For today’s rates of ${pricePerPerson}/person + ${pricePerMile}/mile</span>
      </div>
    </div>
  )
}
